import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allSuppliers: [],
};

export const suppliersSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    setAllSuppliers: (state, action) => {
      state.allSuppliers = action.payload;
    },
  },
});

export const { setAllSuppliers } = suppliersSlice.actions;

export default suppliersSlice.reducer;
